import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JobStatusModel } from './job-service/models/job-status-model';

@Injectable({
  providedIn: 'root'
})
export class JobStatusService {

  constructor(private router: Router) { }

  checkIfPageAccessible(model: JobStatusModel, isFirstIterativeApplicationPart: boolean) {
    
    if ((model.status === 'Closed'
      || this.isPausedButOnApplicantFilePage(model))
      && !this.isPausedButOnPartTwoPage(model, isFirstIterativeApplicationPart)
      && !this.isPausedButCompletingMissingInformation(model)) {
      const jobRoute = this.router.url.toString().split('/jobs/')[0];

      this.router.navigateByUrl(`${jobRoute}/jobs/job-closed`);
    }
  }

  private isPausedButOnApplicantFilePage(model: JobStatusModel): boolean {
    const applicantFileUrlIdentifier = 'applicants';

    return model.status === 'Paused' && this.router.url.toString().indexOf(applicantFileUrlIdentifier) === -1;
  }

  private isPausedButOnPartTwoPage(model: JobStatusModel, isFirstIterativeApplicationPart: boolean): boolean {
    return model.status === 'Paused' && !isFirstIterativeApplicationPart;
  }

  private isPausedButCompletingMissingInformation(model: JobStatusModel): boolean {
    return model.status === 'Paused' && !!sessionStorage.getItem('completeApplicationPartRequestId');
  }
}
